/* eslint-disable jira/filename-case */
import type React from 'react';

import type { ShortcutsConfig } from '@atlassian/global-side-navigation/common/types';
import type { MenuItemConfigData } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/common/types.tsx';
import { useOrderedAppShortcuts } from './useOrderedAppShortcuts.tsx';

interface ReorderShortcutsContainerProps {
	children: (renderProps: {
		shortcuts: ReturnType<typeof useOrderedAppShortcuts>;
	}) => React.ReactNode;
	shortcutsConfig: ShortcutsConfig;
	appItemsData?: MenuItemConfigData[];
}

export const ReorderShortcutsContainer = ({
	shortcutsConfig,
	appItemsData,
	children,
}: ReorderShortcutsContainerProps): React.ReactNode => {
	// sort filtered products based on order of appItemsData
	const orderedShortcuts = useOrderedAppShortcuts(shortcutsConfig, appItemsData);

	return children({ shortcuts: orderedShortcuts });
};
